import React from 'react';
import HomeButton from './common/HomeButton';

const FourOhFour = () => {
  return (
    <div className='onboarding-container'>
      <HomeButton />
      <div className='onboarding-card'>
        <h1>Page not found!</h1>
      </div>
    </div>
  );
};

export default FourOhFour;
